export default "__VITE_ASSET__nAkIbJsK__"